import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Spinner } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { getDriverDetail } from "../../../../api/driver";
import { FileUpload, Input } from "../../../../components";
import dayjs from "dayjs";

const DriverPSV = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const form = useForm();

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getDriverDetail(id);
            setDetail(response);

            // Set form values for PSV details
            if (response.psvLicenseFront) {
                form.setValue("psvLicenseFront", response.psvLicenseFront);
            }
        } catch (error) {
            console.error("Error fetching driver details:", error);
        } finally {
            setLoading(false);
        }
    }, [id, form]);

    useEffect(() => {
        getData();
    }, [getData]);

    const formatDate = (dateString) => {
        return dateString ? dayjs(dateString).format("DD/MM/YYYY") : t("NOT_AVAILABLE");
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">{t("LOADING")}</span>
                </Spinner>
            </div>
        );
    }

    return (
        <FormProvider {...form}>
            <Row>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("PSV_LICENSE_FRONT")}
                        name="psvLicenseFront"
                        readOnly={true}
                        fileName={detail.psvLicenseFront?.originalName || detail.psvLicenseFront?.name}
                        uploadProps={{
                            className: "w-100"
                        }}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <Input
                        label={t("PSV_NUMBER")}
                        name="psvNumber"
                        formControlProps={{
                            disabled: true,
                            value: detail.psvNumber || ""
                        }}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <Input
                        label={t("PSV_EXPIRY_DATE")}
                        name="psvExpiryDate"
                        formControlProps={{
                            disabled: true,
                            value: formatDate(detail.psvExpiryDate)
                        }}
                    />
                </Col>
            </Row>
        </FormProvider>
    );
};

export default DriverPSV;
